// Test Cases Action Types
export const FETCH_TEST_CASES_START = "FETCH_TEST_CASES_START";
export const FETCH_TEST_CASES_SUCCESS = "FETCH_TEST_CASES_SUCCESS";
export const FETCH_TEST_CASES_FAILURE = "FETCH_TEST_CASES_FAILURE";

export const FETCH_TEST_CASE_START = "FETCH_TEST_CASE_START";
export const FETCH_TEST_CASE_SUCCESS = "FETCH_TEST_CASE_SUCCESS";
export const FETCH_TEST_CASE_FAILURE = "FETCH_TEST_CASE_FAILURE";

export const CREATE_TEST_CASE_START = "CREATE_TEST_CASE_START";
export const CREATE_TEST_CASE_SUCCESS = "CREATE_TEST_CASE_SUCCESS";
export const CREATE_TEST_CASE_FAILURE = "CREATE_TEST_CASE_FAILURE";

export const UPDATE_TEST_CASE_START = "UPDATE_TEST_CASE_START";
export const UPDATE_TEST_CASE_SUCCESS = "UPDATE_TEST_CASE_SUCCESS";
export const UPDATE_TEST_CASE_FAILURE = "UPDATE_TEST_CASE_FAILURE";

export const DELETE_TEST_CASE_START = "DELETE_TEST_CASE_START";
export const DELETE_TEST_CASE_SUCCESS = "DELETE_TEST_CASE_SUCCESS";
export const DELETE_TEST_CASE_FAILURE = "DELETE_TEST_CASE_FAILURE";

export const COPY_TEST_CASE_START = "COPY_TEST_CASE_START";
export const COPY_TEST_CASE_SUCCESS = "COPY_TEST_CASE_SUCCESS";
export const COPY_TEST_CASE_FAILURE = "COPY_TEST_CASE_FAILURE";

export const MOVE_TEST_CASE_START = "MOVE_TEST_CASE_START";
export const MOVE_TEST_CASE_SUCCESS = "MOVE_TEST_CASE_SUCCESS";
export const MOVE_TEST_CASE_FAILURE = "MOVE_TEST_CASE_FAILURE";

export const BULK_EDIT_TEST_CASES_START = "BULK_EDIT_TEST_CASES_START";
export const BULK_EDIT_TEST_CASES_SUCCESS = "BULK_EDIT_TEST_CASES_SUCCESS";
export const BULK_EDIT_TEST_CASES_FAILURE = "BULK_EDIT_TEST_CASES_FAILURE";

export const BULK_DELETE_TEST_CASES_START = "BULK_DELETE_TEST_CASES_START";
export const BULK_DELETE_TEST_CASES_SUCCESS = "BULK_DELETE_TEST_CASES_SUCCESS";
export const BULK_DELETE_TEST_CASES_FAILURE = "BULK_DELETE_TEST_CASES_FAILURE";

export const BULK_MOVE_TEST_CASES_START = "BULK_MOVE_TEST_CASES_START";
export const BULK_MOVE_TEST_CASES_SUCCESS = "BULK_MOVE_TEST_CASES_SUCCESS";
export const BULK_MOVE_TEST_CASES_FAILURE = "BULK_MOVE_TEST_CASES_FAILURE";

export const SET_TEST_CASES_FILTERS = "SET_TEST_CASES_FILTERS";
export const CLEAR_TEST_CASES_FILTERS = "CLEAR_TEST_CASES_FILTERS";

export const SET_SELECTED_TEST_CASES = "SET_SELECTED_TEST_CASES";
export const CLEAR_SELECTED_TEST_CASES = "CLEAR_SELECTED_TEST_CASES";
